import React from 'react'
import { Container, Text, VStack, HStack, Flex } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { ContactType, mapToLinkContact } from '@lib/util/link-contact'
import HeadingTag from './heading-tag'

const CONTACT_US_INFO = [
  {
    type: 'Email',
    texts: ['enquiries@jmldirect.com.sg'],
    contact: ContactType.EMAIL
  },
  {
    type: 'Customer Service Hotline',
    texts: ['+65 6386 8686'],
    contact: ContactType.PHONE
  },
  {
    type: 'Whatsapp',
    texts: ['+65 9641 4572'],
    contact: ContactType.WHATSAPP
  }
]

const FIND_US_INFO = [
  {
    location: {
      name: 'JML Service Centre',
      contents: [
        {
          content: '33 Ubi Ave 3, Vertex Tower B'
        },
        {
          content: '#07-16'
        },
        {
          content: 'Singapore 408868'
        }
      ]
    },
    opening_hours: {
      contents: [
        {
          content: 'Monday - Friday',
          subContent: '(Closed on Public Holidays)'
        },
        {
          content: '9:00 am - 6:00 pm',
          subContent: '(1 pm - 2 pm Closed for Lunch)'
        }
      ]
    },
    contact: {
      contents: [
        {
          content: '+65 6742 1771',
          contacts: [ContactType.PHONE]
        }
      ]
    },
    map: 'https://www.google.com/maps?q=33+Ubi+Ave+3+Vertex+Tower+B+Singapore+408868&output=embed'
  },
  {
    location: {
      name: 'JML @ Causeway Point',
      contents: [
        {
          content: '1 Woodlands Square'
        },
        {
          content: '#03-19'
        },
        {
          content: 'Singapore 738099'
        }
      ]
    },
    opening_hours: {
      contents: [
        {
          content: 'Monday - Sunday'
        },
        {
          content: '10:00 am - 9:00 pm'
        }
      ]
    },
    contact: {
      contents: [
        {
          content: '+65 8950 6118',
          contacts: [ContactType.PHONE, ContactType.WHATSAPP]
        }
      ]
    },
    payment_options: {
      contents: [
        {
          content: 'Cash | NETS | Digital Payment'
        }
      ]
    },
    map: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15954.260480807445!2d103.7859471!3d1.4360933!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da13996ab491e1%3A0x4a6c633b2b2aa365!2sJML%40Causeway%20Point!5e0!3m2!1sen!2s!4v1689910898766!5m2!1sen!2s'
  }
]

const ContactContent = ({
  contacts,
  value
}: {
  contacts: ContactType[]
  value: string
}): any => {
  if (contacts.length === 1) {
    return contacts.map((contact, k) => {
      return (
        <Text key={k} textStyle={'contactUsContent'} w={'100%'}>
          <Link href={mapToLinkContact(contact, value)}>{value}</Link>
        </Text>
      )
    })
  } else {
    return contacts.map((contact, k) => {
      return (
        <HStack key={k} w={'100%'}>
          <Text
            textStyle={'contactUsContent'}
            fontWeight={500}
            textTransform={'capitalize'}
          >
            {contact}
          </Text>
          <Text textStyle={'contactUsContent'}>:</Text>
          <Link href={mapToLinkContact(contact, value)}>
            <Text textStyle={'contactUsContent'}>{value}</Text>
          </Link>
        </HStack>
      )
    })
  }
}

const FindUsContents = ({ contents }: { contents: any[] }) => {
  return (
    <VStack w={'100%'} spacing={1}>
      {contents.map((c, k) => {
        return (
          <VStack key={k} w={'100%'} spacing={1}>
            {c.contacts != null ? (
              <ContactContent contacts={c.contacts} value={c.content} />
            ) : (
              <Text textStyle={'contactUsContent'} w={'100%'}>
                {c.content}
              </Text>
            )}
            <Text
              w={'100%'}
              color={'red'}
              fontSize={''}
              fontWeight={600}
              fontFamily={'DM Sans Regular, sans-serif'}
            >
              {c.subContent}
            </Text>
          </VStack>
        )
      })}
    </VStack>
  )
}

const FindUsSubInfo = ({
  name,
  contents
}: {
  name: string
  contents: any[]
}) => {
  return (
    <VStack w={'100%'} spacing={1}>
      <Text textStyle={'contactUsContentBoldMedium'} w={'100%'}>
        {name}
      </Text>
      <FindUsContents contents={contents} />
    </VStack>
  )
}

export const FindUsInfo = ({ info }: { info: any }) => {
  const { location, opening_hours, contact, payment_options, map } = info

  return (
    <Flex
      w={'100%'}
      h={{ md: '1050px', lg: '550px' }}
      flexDirection={{ base: 'column', md: 'row' }}
      gap={5}
    >
      <VStack w={'100%'} spacing={8} flex={1}>
        {location && (
          <FindUsSubInfo name={location?.name} contents={location.contents} />
        )}
        {opening_hours && (
          <FindUsSubInfo
            name={'Opening Hours:'}
            contents={opening_hours.contents}
          />
        )}
        {contact && (
          <FindUsSubInfo name={'Contact:'} contents={contact.contents} />
        )}
        {payment_options && (
          <FindUsSubInfo
            name={'Payment Options:'}
            contents={payment_options.contents}
          />
        )}
      </VStack>

      <VStack w={'100%'} flex={1.5}>
        <div
          style={{ width: '100%' }}
          dangerouslySetInnerHTML={{
            __html: `<div class="mapouter"><div class="gmap_canvas">
            <iframe class="gmap_iframe" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="${
              map as string
            }"></iframe>
            </div><style>.mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:600px;}.gmap_iframe {width:100%!important;height:500px!important;}</style></div>`
          }}
        ></div>
      </VStack>
    </Flex>
  )
}

const ContactUs = () => {
  const Experience_Store = FIND_US_INFO.slice(1)

  const router = useRouter()

  return (
    <Container maxW={'1100px'} my={24}>
      <VStack spacing={6}>
        <HeadingTag>Contact Us</HeadingTag>
        <Text textStyle={'contactUsContent'} w={'100%'}>
          Habbit (JML) is a brand by JML Singapore Pte Ltd. All Customer Service
          & Store will be done under both Habbit and JML Singapore Pte Ltd.
        </Text>
        <VStack w={'100%'} spacing={2}>
          {CONTACT_US_INFO.map((info, k) => {
            return (
              <HStack w={'100%'} key={k} alignItems={'start'}>
                <Text textStyle={'contactUsContentBold'}>{info.type}:</Text>
                <VStack spacing={0} align={'start'}>
                  {info.texts.map((t, i) => (
                    <Link key={i} href={mapToLinkContact(info.contact, t)}>
                      <Text textStyle={'contactUsContent'}>{t}</Text>
                    </Link>
                  ))}
                </VStack>
              </HStack>
            )
          })}
        </VStack>
      </VStack>
      <VStack spacing={5} my={16}>
        <Text textStyle={'sectionHeader'} w={'100%'}>
          Find Us
        </Text>
        <Text textStyle={'contactUsContentBoldLarge'} w={'100%'}>
          Customer Service Centre
        </Text>
        <VStack w={'100%'} spacing={1}>
          <Text textStyle={'contactUsContent'} w={'100%'}>
            In light of the heightened alert measures, all customer
            service-related requests that require a visit to the JML service
            centre will strictly be on an appointment basis only.
          </Text>
          <Text textStyle={'contactUsContent'} w={'100%'}>
            We reserve the right to reject any visits without an appointment. We
            seek your kind understanding to keep everyone safe.
          </Text>
        </VStack>
        <VStack w={'100%'}>
          <FindUsInfo info={FIND_US_INFO[0]} />
        </VStack>
      </VStack>
      <VStack spacing={7} id="experience-store">
        <Text textStyle={'contactUsContentBoldLarge'} w={'100%'}>
          Experience Store
        </Text>
        <VStack w={'100%'} mt={5} spacing={32}>
          {Experience_Store.map((es, k) => {
            return (
              <VStack w={'100%'} key={k}>
                <FindUsInfo info={es} />
              </VStack>
            )
          })}
        </VStack>
      </VStack>
    </Container>
  )
}

export default ContactUs
